<div
  *ngIf="reasons?.length"
  class="reasons-container"
>
  <mat-radio-group
    *ngIf="!multiple; else multiReasons"
    [(ngModel)]="selectedReason"
    (change)="reasonChange([{ selected: true, value: $event.value, name: $event.value }]);"
  >
    <mat-radio-button
      class="reason"
      *ngFor="let reason of transformedReasons"
      [value]="reason.value"
    >
      {{reason.name}}
    </mat-radio-button>
  </mat-radio-group>
</div>

<ng-template #multiReasons>
  <mojo-checkboxes
    [(checkboxes)]="transformedReasons"
    class="secondary-checkbox"
    (checkboxesChange)="reasonChange($event)"
  >
  </mojo-checkboxes>
</ng-template>
